export const COIN_IDS = {
  BTC: 'bitcoin',
  ETH: 'ethereum',
  LTC: 'litecoin',
  KDA: 'kadena'
} as const;

export const COINWARZ_COINS = {
  BTC: 'BTC',
  LTC: 'LTC'
} as const;

export const API_ENDPOINTS = {
  COINGECKO: 'https://api.coingecko.com/api/v3',
  COINWARZ: 'https://www.coinwarz.com/v1/api',
  BLOCKCHAIR: 'https://api.blockchair.com'
} as const;

// Cache settings
export const CACHE_CONFIG = {
  TTL: 60000, // 1 minute
  RATE_LIMIT: 5000 // 5 seconds between requests
};

// Error messages
export const ERROR_MESSAGES = {
  OFFLINE: 'You are offline. Using cached data.',
  API_ERROR: 'Unable to fetch real-time data. Using cached data.',
  RATE_LIMIT: 'Rate limit exceeded. Using cached data.',
  TIMEOUT: 'Request timed out. Using cached data.',
  INVALID_DATA: 'Invalid data received. Using cached data.'
} as const;

// API response types
export const RESPONSE_TYPES = {
  JSON: 'application/json',
  TEXT: 'text/plain'
} as const;

// HTTP methods
export const HTTP_METHODS = {
  GET: 'GET',
  POST: 'POST',
  PUT: 'PUT',
  DELETE: 'DELETE'
} as const;

// Request timeouts (in milliseconds)
export const TIMEOUTS = {
  DEFAULT: 10000,    // 10 seconds
  EXTENDED: 30000,   // 30 seconds
  SHORT: 5000        // 5 seconds
} as const;

// Batch processing
export const BATCH_CONFIG = {
  SIZE: 10,          // Number of items per batch
  DELAY: 1000,       // Delay between batches
  MAX_RETRIES: 3     // Maximum retry attempts
} as const;